(function (window, document) {
  "use strict";

  var DNB = window.DNB;
  var COOKIE_PREFIX = "sa_catalog_dl_";
  var COOKIE_DAYS = 365;
  var ENDPOINT = "/save-catalog-download-form";
  var activeConsentKey = "";

  function cookieName(key) {
    return COOKIE_PREFIX + encodeURIComponent(key || "unknown");
  }

  function getCookie(name) {
    var parts = ("; " + document.cookie).split("; " + name + "=");
    if (parts.length === 2) {
      return decodeURIComponent(parts.pop().split(";").shift() || "");
    }
    return "";
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 86400000).toUTCString();
    var secure = window.location.protocol === "https:" ? ";Secure" : "";
    document.cookie = name + "=" + encodeURIComponent(value) + ";path=/;expires=" + expires + ";SameSite=Lax" + secure;
  }

  function hasConsent(key) {
    if (!key) return false;
    var name = cookieName(key);
    return getCookie(name) === "1" || window.localStorage.getItem(name) === "1";
  }

  function storeConsent(key) {
    if (!key) return;
    var name = cookieName(key);
    setCookie(name, "1", COOKIE_DAYS);
    try {
      window.localStorage.setItem(name, "1");
    } catch (e) { /* ignore */ }
  }

  function openFile(url) {
    if (!url) return;
    window.open(url, "_blank", "noopener");
  }

  function bindFieldValidation(form, contactForm) {
    if (!contactForm) return;

    Array.prototype.forEach.call(form.querySelectorAll('[data-rule="phone"], [data-rule="phone-optional"]'), function (input) {
      contactForm._initPhoneField(input);
    });

    var controls = form.querySelectorAll(".form-field__control, .form-check__input");
    Array.prototype.forEach.call(controls, function (ctrl) {
      var ev = ctrl.tagName === "SELECT" || ctrl.type === "checkbox" ? "change" : "input";
      ctrl.addEventListener(ev, function () {
        var wrap = ctrl.closest(".form-field, .form-check");
        if (wrap && contactForm._checkControl(ctrl)) {
          wrap.classList.remove("is-error");
        }
      });
    });
  }

  function validateForm(form, contactForm) {
    if (contactForm && typeof contactForm._validate === "function") {
      return contactForm._validate(form);
    }
    return true;
  }

  function parseModuleId(raw) {
    var n = parseInt(String(raw || ""), 10);
    return isNaN(n) || n <= 0 ? null : n;
  }

  function resolveConsentKey(link) {
    return link.getAttribute("data-consent-key")
      || link.getAttribute("data-product-module-id")
      || link.getAttribute("data-product-slug")
      || "unknown";
  }

  function fillFormFromLink(form, link) {
    var productNameField = form.querySelector('[name="productName"]');
    var productSlugField = form.querySelector('[name="productSlug"]');
    var moduleIdField = form.querySelector('[name="productModuleId"]');
    var productFromLink = link.getAttribute("data-product-name") || "";

    if (productNameField) {
      productNameField.value = productFromLink;
    }
    if (productSlugField) {
      productSlugField.value = link.getAttribute("data-product-slug") || "";
    }
    if (moduleIdField) {
      moduleIdField.value = link.getAttribute("data-product-module-id") || "";
    }

    form.querySelector('[name="fileUrl"]').value = link.getAttribute("data-file-url") || link.getAttribute("href") || "";
    form.querySelector('[name="fileName"]').value = link.getAttribute("data-file-name") || "";
  }

  function handleDownloadClick(e, form, errorNote) {
    var link = e.target.closest("[data-catalog-download]");
    if (!link) return;

    var url = link.getAttribute("data-file-url") || link.getAttribute("href") || "";
    activeConsentKey = resolveConsentKey(link);

    if (hasConsent(activeConsentKey)) {
      e.preventDefault();
      openFile(url);
      return;
    }

    e.preventDefault();
    fillFormFromLink(form, link);
     
    if (errorNote) {
      errorNote.hidden = true;
    }
    if (DNB.Modal && DNB.Modal.open) {
      DNB.Modal.open("catalogDownloadModal");
    }
  }

  DNB.CatalogDownload = {
    init: function () {
      var form = document.querySelector("[data-catalog-download-form]");
      if (!form) return;

      var contactForm = DNB.ContactForm;
      var errorNote = form.querySelector("[data-catalog-download-error]");
      var submitBtn = form.querySelector("[data-catalog-download-submit]");

      bindFieldValidation(form, contactForm);

      document.addEventListener("click", function (e) {
        handleDownloadClick(e, form, errorNote);
      });

      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (!validateForm(form, contactForm)) {
          return;
        }

        var phoneField = form.querySelector('[name="phone"]');
        var moduleIdField = form.querySelector('[name="productModuleId"]');

        var firstNameEl = form.querySelector('[name="firstName"]');
        var lastNameEl = form.querySelector('[name="lastName"]');
        var positionEl = form.querySelector('[name="position"]');
        var consentEl = form.querySelector('[name="consent"]');
        var phoneDigits = phoneField ? phoneField.value.replace(/\D/g, "") : "";

        var payload = {
          firstName: firstNameEl ? firstNameEl.value.trim() : "",
          lastName: lastNameEl ? lastNameEl.value.trim() : "",
          companyName: form.querySelector('[name="companyName"]').value.trim(),
          position: positionEl ? positionEl.value.trim() : "",
          email: form.querySelector('[name="email"]').value.trim(),
          phone: phoneDigits.length ? phoneDigits : null,
          privacyKvkk: !!(consentEl && consentEl.checked),
          productName: form.querySelector('[name="productName"]').value,
          productSlug: form.querySelector('[name="productSlug"]') ? form.querySelector('[name="productSlug"]').value : "",
          productModuleId: moduleIdField ? parseModuleId(moduleIdField.value) : null,
          fileName: form.querySelector('[name="fileName"]').value,
          fileUrl: form.querySelector('[name="fileUrl"]').value,
          language: form.querySelector('[name="language"]').value
        };

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.getAttribute("data-sending") || "Gönderiliyor...";
        }
        if (errorNote) {
          errorNote.hidden = true;
        }

        fetch(ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        })
          .then(function (res) { return res.json().catch(function () { return { success: false }; }); })
          .then(function (data) {
            if (!data || !data.success) {
              throw new Error((data && data.message) || "error");
            }
            storeConsent(activeConsentKey);
            if (DNB.Modal && DNB.Modal.close) {
              DNB.Modal.close();
            }
            openFile(payload.fileUrl);
          })
          .catch(function (err) {
            if (errorNote) {
              if (err && err.message && err.message !== "error") {
                errorNote.textContent = err.message;
              }
              errorNote.hidden = false;
            }
          })
          .finally(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = submitBtn.getAttribute("data-label") || "Gönder";
            }
          });
      });
    }
  };
})(window, document);
